import React, { useRef, useState } from 'react'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { enumUtil } from '../../../../utils/Enum';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
import { ServerRequestProtected, ServerRequestPublic } from '../../../../utils/ServerDataRequest';
// import Modal from 'react-bootstrap/Modal';
import AmountFormatter from '../../../../utils/AmountFormatter';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import isNull from '../../../../utils/NullChecking';
import Loader from '../../../shared/Loader/Loader';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import noData from "./../../../../assets/img/NoDataFound.svg"
import NotificationHandler from '../../../../utils/NotificationHandler';
import { isChildWindow } from '../../../../utils/Constants';

const useLoadPDFDataChildWindow = () => {
  const EOBViewData = [
    { display: 'System Generated EOB', value: 'System Generated EOB' },
    { display: 'Clearing House EOB', value: 'Clearing House EOB' },
  ];
  const API_URL = enumUtil.controller.Payment;
  const API_URL_GENERAL = enumUtil.controller.General;
  const componentRef = useRef(null);
  let EOB_View_Modal = {
    EOBViewType: 'Clearing House EOB',
  }
  const API_URL_Wasabi = enumUtil.controller.Wasabi
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [is, setIs] = useState(true);
  const [mainEOBView, setMainEOBView] = useState(EOB_View_Modal);
  // const [txtFile, setTxtFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [pdfFile, setPdfFile] = useState(null);
  // const [filePath, setFilePath] = useState(null);

  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [pdfData, setPdfData] = useState({})
  const [showPDF, setShowPDF] = useState(false);

  const handleProcessedAs = (value) => {
    switch (value) {
      case "1": return " Primary"
      case "2": return " Secondary"
      case "3": return " Tertiary"
      case "4": return " Denied"
      case "19": return " Primary, Forwarded"
      case "20": return " Secondary, Forwarded"
      case "21": return " Tertiary, Forwarded"
      case "22": return " Reversal"
      case "23": return " Not Our Claim, Forwarded"
      case "25": return " Predetermination Pricing Only - No Payment"
      default:
        break;
    }
  }
  const handleOpenPdf = (row, SearchByControlNumber) => {

    let { ID, Type, PayerClaimControlNum, HeaderID, ...rest } = { ...row }

    LoadPdfData((ID || HeaderID), SearchByControlNumber ? PayerClaimControlNum : null, Type);
  }

  const closeModal = () => {
    setMainEOBView(EOB_View_Modal);
    setShowPDF(false);
    setPdfFile(null);
    // setFilePath(null);
    setIs(true);
  }

  const handleChange = (e) => {
    setIs(false);
    let { name, value } = e.target
    let modal = { ...mainEOBView };
    // let saveModal = { ...goalsSaveUpdateModal }
    modal[name] = value
    setMainEOBView(modal)
    for (var property in EOB_View_Modal) {
      if (name === property) {
        // saveModal[name] = value
      }
    }
    // setEOBViewsSaveUpdateModal(saveModal)
  }

  const handleSelectedData = (selectedData, name, type, mode) => {
    setIs(true);
    let modal = { ...mainEOBView };
    if (type === 'client' && !isNull(selectedData)) {
      if (name === "EOBViewType") {
        modal[name] = selectedData.display
        // goalsSaveUpdateModal[name] = selectedData.value + "";
        // setProviderID(selectedData.value + "")
        // if(selectedData.display === "Clearing House EOB"){
        //   (filePath && !pdfFile) && ViewPdf();
        // }
      }
    } else if (type === 'server' && !isNull(selectedData)) {

    } else {
      modal[name] = ''
      // goalsSaveUpdateModal[name] = ''
    }
    setMainEOBView(modal)
    return selectedData
  }

  const ViewPdf = (filePath) => {
    setPdfFile(null)
    if (!(filePath && !pdfFile)) {
      setIsLoading(false);
      return;
    }
    ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
      "BucketPath": filePath
    }, 'Download').then((response) => {
      setIsLoading(false)
      if (response.type === 'application/txt') {
        const blob = response;
        const reader = new FileReader();
        reader.onload = () => {
          const content = reader.result;
          // setTxtFile(content);
        };
        reader.readAsText(blob, 'utf-8');
      } else if (response.type === 'application/png' || response.type === 'application/jpg' || response.type === 'application/jepg') {
        const blob = response
        const objectURL = URL.createObjectURL(blob);
        // setImgFile(objectURL)
      } else if (response.type === 'application/tiff') {

      }
      else {
        let file = new Blob([response]);
        const fileUrl = URL.createObjectURL(file);
        setPdfFile(fileUrl)
      }
      setShowPDF(true)
    }).catch((error) => {
      setIsLoading(false)
      NotificationHandler('File Not Found', enumUtil.enumtoaster.error);
    })
  }

  const LoadPdfData = (id, controlNumber, type) => {
    setIsLoadingPDF(true);

    ServerRequestProtected(API_URL + "/ERAPaymentsPDF", 'post', {
      "TableName": enumUtil.enumAPITableName.ERAPaymentsPDF,
      "ID": id,
      ...(controlNumber ? { "SearchParam": controlNumber } : {}),
    }).then((response) => {
      setPdfData(response);
      setShowPDF(true);
      setIsLoadingPDF(false);
      LoadClearingHousePdfPath(id);
    }).catch((error) => {
      setIsLoadingPDF(false);
    })
  }
  const LoadClearingHousePdfPath = (id) => {
    setIsLoading(true)
    ServerRequestProtected(API_URL_GENERAL + "/FindByID", 'post', {
      "TableName": enumUtil.enumAPITableName.ERAPaymentsPDF,
      "ID": id,
    }).then((response) => {
      ViewPdf(response?.FilePath);
    }).catch((error) => {
      setIsLoading(false)
    })
  }
  const captureDataAndGeneratePDF = () => {
    setIsLoadingPDF(true); // Show loadert
    const parentElement = componentRef.current.parentElement;
    // Add a class to the parent element
    parentElement.classList.add('EOB-remove-scroll');

    const element = componentRef.current;
    // Temporarily adjust styles to ensure the full content is captured without shifting
    const originalOverflow = element.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;
    // Hide overflow and ensure content is fully visible
    element.style.overflow = 'visible';
    document.body.style.overflow = 'hidden';
    // Wait for the next frame to ensure layout adjustments are rendered
    setTimeout(() => {
      html2canvas(element, {
        useCORS: true, // Allow external resources like fonts and images
        scrollX: 0,
        scrollY: 0,
        scale: 2, // Increase resolution for higher quality
        width: element.scrollWidth, // Capture full width
        height: element.scrollHeight, // Capture full height
      }).then((canvas) => {
        // Create a new PDF document
        const pdf = new jsPDF('p', 'mm', 'a4');
        // Get the image data
        const imgData = canvas.toDataURL('image/jpeg', 0.6); // Use JPEG with 70% quality
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        // Add the image to the PDF
        let position = 0;
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
        // If the image is taller than one page, add additional pages
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        // Save the PDF
        pdf.save('EOB.pdf');
        // Restore the original overflow
        element.style.overflow = originalOverflow;
        document.body.style.overflow = originalBodyOverflow;

        setIsLoadingPDF(false); // Hide loader
      }).catch(() => {
        // Restore original styles on error
        element.style.overflow = originalOverflow;
        document.body.style.overflow = originalBodyOverflow;
        setIsLoadingPDF(false); // Hide loader
      }).finally(() => {
        parentElement.classList.remove('EOB-remove-scroll');
      });
    }, 100); // Adjust timeout if needed
  };

  let pdfContent =
    <>
      <div className="ar_print-header">
        <div className='pdf_perview clr_cccccc d-flex justify-content-between align-items-center'>
          {/* {isLoadingPDF ? <Loader /> : null} */}
          <p className='heading fs-16'>Preview</p>
          <div className="d-flex align-items-center gap-2">
            <div className="form-group input mb-0">
              <div className={'input form-group ar-multiple-br m-0 w-164px'}>
                <SuperSearchList
                  type="client"
                  id='EOBViewType'
                  name='EOBViewType'
                  icon={'Simple'}
                  sup_btn='sup_btn'
                  sup_inp='superSearchVisitInp'
                  searchValue={mainEOBView.EOBViewType}
                  data={EOBViewData}
                  onChange={handleChange}
                  getSelectedData={handleSelectedData}
                  is={is}
                />
              </div>
            </div>
            <div className='d-flex align-items-baseline gap-2'>
               {mainEOBView.EOBViewType === 'System Generated EOB' &&
                  <i className='icon-Group-482289' onClick={captureDataAndGeneratePDF}></i>}
                {/*<i className='icon-Icon-metro-cross' onClick={closeModal}></i> */}
            </div>
          </div>
        </div>
      </div>
      {mainEOBView.EOBViewType === 'System Generated EOB' ?
        <div className='za_content mt-2' ref={componentRef}>
          <p className='heading fs-12 heading_bg'>Check Information</p>
          <div className='content-1'>
            <p className='text font-m fs-12 mb-1'>{pdfData?.Header?.[0]?.PayerName}</p>
            <p className='text  fs-12'>{pdfData?.Header?.[0]?.PayerAddress}</p>
            {/* <p className='text  fs-12'>WESTMORELAND, NY 134909998</p> */}
            <div className='d-flex mt-1'>
              <div className='col-md-4'>
                <div className='d-flex mt-1'>
                  <p className='col-md-6 heading fs-12'>EFT/Check #</p>
                  <p className='col-md-6 text font-m fs-11 ar-light-color' >{pdfData?.Header?.[0]?.CheckNumber}</p>
                </div>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Check Amt</p>
                  <p className='col-md-6 text font-m fs-11  ar-light-color' ><AmountFormatter amount={pdfData?.Header?.[0]?.CheckAmount} /></p>
                </div>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>NPI/Group</p>
                  <p className='col-md-6 text font-m fs-11 ar-light-color' >{pdfData?.Header?.[0]?.RenderingProviderNPI}</p>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Check Date</p>
                  <p className=' col-md-6 text fs-12  ar-light-color' >{pdfData?.Header?.[0]?.CheckDate}</p>
                </div>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Provider Adj Amt</p>
                  <p className=' col-md-6 text fs-12 ar-light-color' >$0.00</p>
                </div>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Provider Number</p>
                  <p className=' col-md-6 text fs-12 ar-light-color' >$0.00</p>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Provider #</p>
                  <p className=' col-md-6 text fs-12 ar-light-color' >N/A</p>
                </div>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Provider Tax ID #</p>
                  <p className=' col-md-6 text fs-12 ar-light-color' >N/A</p>
                </div>
                <div className='d-flex mt-1'>
                  <p className=' col-md-6 heading fs-12'>Created Date</p>
                  <p className=' col-md-6 text fs-12 ar-light-color'>{pdfData?.Header?.[0]?.CheckDate}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column gap-10">
            {pdfData?.VisitPayment?.length > 0 ?
              pdfData.VisitPayment.map(visit => {
                let totals = visit?.ServicelinePayment?.length > 0
                  ? visit.ServicelinePayment.reduce(
                    (acc, serviceLine) => {
                      acc.Billed += parseFloat(serviceLine.Billed || 0); // Sum up Billed values
                      acc.Allowed += parseFloat(serviceLine.Allowed || 0); // Sum up Allowed values
                      acc.CoIns += parseFloat(serviceLine.CoIns || 0); // Sum up CoIns values
                      acc.Copay += parseFloat(serviceLine.Copay || 0); // Sum up Copay values
                      acc.LateFilingRed += parseFloat(serviceLine.LateFilingRed || 0); // Sum up LateFilingRed values
                      acc.OtherAdjusts += parseFloat(serviceLine.OtherAdjusts || 0); // Sum up OtherAdjusts values
                      acc.ProviderPaid += parseFloat(serviceLine.ProviderPaid || 0); // Sum up ProviderPaid values
                      return acc;
                    },
                    {
                      Billed: 0,
                      Allowed: 0,
                      CoIns: 0,
                      Copay: 0,
                      LateFilingRed: 0,
                      OtherAdjusts: 0,
                      ProviderPaid: 0,
                    }
                  )
                  : { Billed: 0, Allowed: 0, CoIns: 0, Copay: 0, LateFilingRed: 0, OtherAdjusts: 0, ProviderPaid: 0, };
                return (
                  <>
                    <div className="heading_bg">
                      <div className='heading fs-12  '>
                        <div className='d-flex align-items-center gap-35 mb-10'>
                          <div className='d-flex align-items-center gap-6'>
                            <p className='heading fs-12 pe-20 br-right-1 br-clr'>Claim ID: <span className='text fs-12'>{visit.ClaimID}</span></p>
                            <p className='heading fs-12 pe-20 br-right-1 br-clr'>Processed As: <span className='text fs-12'>{visit.ClaimStatus ? <span>{handleProcessedAs(visit.ClaimStatus)}</span> : 'N/A'}</span></p>
                          </div>

                          <p className='heading fs-12 pe-12 br-right-1 br-clr'>Payer Claim #: <span className='text fs-12'>{visit.ICN}</span></p>

                          <div className='d-flex align-items-center gap-1'>
                            <p className='heading fs-12 '>Claim Amt:</p>
                            <p className='text fs-12 pe-12 br-right-1 br-clr claim-amt px-2'>{<AmountFormatter amount={visit?.TotalClaimAmount} />}</p>
                          </div>

                          <div className='d-flex align-items-center gap-1'>
                            <p className='heading fs-12 '>Paid:</p>
                            <p className='text fs-12 pe-12 br-right-1 br-clr claim-amt px-2'>{<AmountFormatter amount={visit?.ClaimPaymentAmount} />}</p>
                          </div>

                          <div className='d-flex align-items-center gap-1'>
                            <p className='heading fs-12 pe-2'>Patient Resp. :</p>
                            <p className='text fs-12 pe-12 br-right-1 br-clr claim-amt px-2'>{<AmountFormatter amount={visit.PatientResponsibility} />}</p>
                          </div>

                          <p className='heading fs-12 pe-12 '>Patient: <span className='text fs-12'>{visit.PatientName}</span></p>

                        </div>

                        <div className='d-flex align-items-center gap-25'>
                          <p className='heading fs-12 pe-2 br-right-1 br-clr'>Insured Name: {visit.InsuredName}</p>
                          <p className='heading fs-12 pe-4 br-right-1 br-clr'>Member ID: <span className='text fs-12'>{visit.MemberIdentification}</span></p>
                          {/* <p className='heading fs-12 pe-4 br-right-1 br-clr'>Insured Member Identification: <span className='text fs-12'>{visit.InsuredMemberIdentification}</span></p> */}
                          <p className='heading fs-12 pe-4 br-right-1 br-clr'>Rendering Provider: <span className='text fs-12'>{visit.RenderingProvider}</span></p>
                          <p className='heading fs-12 pe-4 '>Rendering NPI: <span className='text fs-12'> {visit.RenderingNPI}</span></p>

                        </div>
                      </div>
                      {/* <div className='br-top-1 ar-border-color'>
                    <p className='heading fs-12 heading_bg '>Service Line Information </p>
                </div> */}
                      {/* ad-expand-table */}
                      <div className='card-body hk-expand-table ad-expand-table service_line pb-2 mt-10'>
                        <table className='w-100'>
                          <thead>
                            <tr>
                              <th ><span className='heading text-nowrap'>CPT/Units</span></th>
                              <th> <span className='heading text-nowrap'>DOS</span></th>
                              <th> <span className='heading text-nowrap'>Billed </span></th>
                              <th><span className='heading text-nowrap'>Allowed </span></th>
                              <th> <span className='heading text-nowrap'>Paid</span></th>
                              <th> <span className='heading text-nowrap'>Copay</span></th>
                              <th><span className='heading text-nowrap'>Co Ins</span></th>
                              <th><span className='heading text-nowrap'>Deduct</span></th>
                              <th> <span className='heading text-nowrap'>Sec </span></th>
                              <th><span className='heading text-nowrap'>Cont. Adj</span></th>
                              <th><span className='heading text-nowrap'>Sequestration</span></th>
                              <th><span className='heading text-nowrap'>Denial 1</span></th>
                              <th><span className='heading text-nowrap'>Denial 2</span></th>
                              <th><span className='heading text-nowrap'>Remark Codes</span></th>
                              <th><span className='heading text-nowrap'>Payer Claim #</span></th>
                            </tr>
                          </thead>
                          <tbody>
                            {visit?.ServicelinePayment?.length > 0 ?
                              visit.ServicelinePayment.map(serviceline =>
                                <tr>
                                  <td><span className='text'>{serviceline.CPT} {serviceline.Units ? `/${serviceline.Units}` : serviceline.Units}</span></td>
                                  <td><span className='text'>{serviceline.DOS}</span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.Billed} /></span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.Allowed} /></span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.Paid} /></span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.Copay} /></span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.CoIns} /></span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.Deduct} /></span></td>
                                  <td><span className='text'>{['True', 'true', true, '1'].includes(serviceline.TransToSec) ? <div class="blue-tick"><i class="icon-check fs-15"></i></div> : <></>}</span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.WriteOffAmt} /></span></td>
                                  <td><span className='text'><AmountFormatter amount={serviceline.Sequestration} /></span></td>
                                  <td><span className='text'>{serviceline.Denial1}</span></td>
                                  <td><span className='text'>{serviceline.Denial2}</span></td>
                                  <td><span className='text'>{serviceline?.Remarkcodes}</span></td>
                                  <td><span className='text'>{serviceline.PayerClmCtrlNum}</span></td>
                                </tr>
                              ) :
                              <></>}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )
              }) : <></>}
          </div>
          <p className='heading fs-12  heading_bg'>Glossary of Codes </p>
          <div className='py-10 px-12'>
            {pdfData?.Glossary?.length > 0 ?
              pdfData.Glossary.map(item => (
                <div className='d-flex align-items-center gap-6 mb-2'>
                  <div className='za-rectangle'></div>
                  <p className='text fs-12 py-1'><span className='me-2'>{item.Code}:</span>{item.Description}</p>
                </div>
              )) : <></>}
          </div>
        </div>
        :
        <>
          {/* {isLoading ?  : null} */}
          {isLoading ? <Loader /> :
            <div className='za_content my-2 hover-scrollbar'>
              {pdfFile ?
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  <Viewer fileUrl={pdfFile}
                    defaultScale={SpecialZoomLevel?.PageWidth}
                    plugins={[defaultLayoutPluginInstance]} />
                </Worker> :
                <div className='no_data'>
                  <div>
                    <img src={noData} />
                    <p>No Data Found</p>
                  </div>
                </div>}
            </div>
          }
        </>}
    </>;

  let pdfDiv = isChildWindow ?
    <div className='ar_view_EOB-child-window h-100'>
      {pdfContent}
    </div>
    : <></>;
  return { isLoadingPDF, componentRef, handleOpenPdf, captureDataAndGeneratePDF, pdfDiv }
}

export default useLoadPDFDataChildWindow